import { IStopsInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const stopsSelector = (state: RootState) => state.stops;

const stopsListSelector = createSelector([stopsSelector], (stops: IStopsInitialState) => stops.stopsList);

const stopSelector = createSelector([stopsSelector], (stops: IStopsInitialState) => stops.stop);

export const stopsSel = {
    stopsSelector,
    stopSelector,
    stopsListSelector,
};
